import { select2RequiredSchema, stringRequiredSchema, stringValidation } from "utils/validation/validationHelpers";
import { object } from 'yup';

const validationSchema = (descriptionLength) => {
    return object().shape({
        title: stringValidation("Assessment name", { max: descriptionLength }),
        description: stringRequiredSchema,
        tableType: select2RequiredSchema,
    })
};

export default validationSchema;